import { MutableRefObject, useEffect } from 'react';

export default function useDetectEscape(
  callback: () => void,
  ref?: MutableRefObject<HTMLDivElement | HTMLButtonElement | null>
) {
  const escapeFunction = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      console.log(ref?.current, event.target, 'esc');
      if (ref && !ref.current?.contains(event.target as Node)) return;
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escapeFunction);
    return () => document.removeEventListener('keydown', escapeFunction);
  });
}
